import React, {useState} from "react";
import {Form, InputGroup} from "react-bootstrap";

export function AGCPassword({formik, name, toolTip, id, placeHolder, value, forUpdate = false, required=true}) {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <Form.Label className={required ? 'required' : ''}>{name}</Form.Label>
            <InputGroup>
                <Form.Control
                    id={id}
                    type={showPassword ? "text" : "password"}
                    placeholder={placeHolder}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={forUpdate}
                    value={value}
                />
                <InputGroup.Text
                    onClick={togglePasswordVisibility}
                    style={{cursor: 'pointer'}}
                    title={showPassword ? "Hide password" : "Show password"}
                >
                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </InputGroup.Text>
            </InputGroup>
            <Form.Text className="text-muted">{toolTip}</Form.Text>
        </>
    );
}
